import { computed, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Auth } from '@core/services';
import { UserRole } from '@core/interfaces/role.interface';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(Auth);
  const router = inject(Router);

  const user = computed(() => authService.user || {});
  const isAdmin = computed(() => user().role?.name === UserRole.ADMIN);

  if (!isAdmin()) {
    router.navigate(['/login']);
    localStorage.clear();
    return false;
  }

  return true;
};
